import MessagePanel from "./message-panel";

export default MessagePanel;